import * as React from 'react';
import { HSLColor, SketchPicker } from 'react-color';
import Draggable from 'react-draggable';
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render from 'source/app/presentation/Shared/Render';
import { Style } from 'source/app/presentation/Shared/Styles/CSS';
import IconWithText from 'source/app/services/Shared/IconWithText/IconWithText';

export const ColorPicker = ({
	color,
	setColor
}: {
	color: HSLColor;
	setColor: React.Dispatch<React.SetStateAction<HSLColor>>;
}) => {
	const [ displayPicker, setDisplayPicker ] = React.useState(false);

	return (
		<span>
			<IconWithText
				id="toggleColorPicker"
				iconSuffix={EGlyphicon['text-color']}
				whenClicked={() => setDisplayPicker(!displayPicker)}
				displayAsBlock={false}
			>
				{GetColorString(color)}
			</IconWithText>
			<Render id="colorPicker" when={displayPicker}>
				<Draggable>
					<div
						style={Style(`colorPickerModal`, {
							position: `absolute`,
							zIndex: 2,
							left: `50%`
						})}
					>
						<SketchPicker
							color={color}
							onChangeComplete={(color) =>
								setColor({
									h: color.hsl.h,
									s: Math.floor(color.hsl.s * 100), // Accommodating what seems like a bug
									l: Math.floor(color.hsl.l * 100), // Accommodating what seems like a bug
									a: color.hsl.a
								})}
						/>
					</div>
				</Draggable>
			</Render>
		</span>
	);
};

export const GetColorString = (color: HSLColor) =>
	`hsla(${Math.floor(color.h)},${color.s}%,${color.l}%,${color.a})`;
